module.exports = __webpack_public_path__ + "img/flowersetting_01.10a9f201.jpg";